/* Wicked accessibility improvements: progressively enhance third-party carousel controls. */
(function () {
  'use strict';
  function enhance(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.flickity-page-dots').forEach(function (dots) {
      dots.setAttribute('aria-label', 'Carousel slide selection');
      dots.querySelectorAll('li.dot').forEach(function (dot, index) {
        dot.setAttribute('role', 'button');
        dot.setAttribute('tabindex', '0');
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        dot.setAttribute('aria-pressed', dot.classList.contains('is-selected') ? 'true' : 'false');
        if (!dot.dataset.wickedKeyboard) {
          dot.dataset.wickedKeyboard = '1';
          dot.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault(); dot.click();
            }
          });
        }
      });
    });
    root.querySelectorAll('button.search_header__submit').forEach(function (button) {
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', 'Submit search');
    });
    root.querySelectorAll('#nt_backtop').forEach(function (link) {
      link.setAttribute('aria-label', 'Back to top');
    });
    root.querySelectorAll('.cat_grid_item__link').forEach(function (link) {
      if (!link.getAttribute('aria-label')) {
        var title = link.closest('.cat_grid_item');
        var heading = title && title.querySelector('.cat_grid_item__title');
        if (heading && heading.textContent.trim()) link.setAttribute('aria-label', 'Shop ' + heading.textContent.trim());
      }
    });
    root.querySelectorAll('a.facebook, a.instagram, a.pinterest, a.twitter, a.youtube, a.tiktok').forEach(function (link) {
      if (!link.getAttribute('aria-label')) {
        var text = link.querySelector('.tt_txt');
        if (text && text.textContent.trim()) link.setAttribute('aria-label', text.textContent.trim());
      }
    });
  }
  function run() { enhance(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  });
  function start() { observer.observe(document.body, {childList:true, subtree:true}); }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
